import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function LoginPage() {
    const { login } = useAuth();
    const location = useLocation();
    const state = location.state as { referrer?: Location };
    const redirectUrl = state?.referrer?.pathname || '/';
    const handleLogin = () => {
        login({ state: { redirectUrl } });
    };

    return (
        <div className="main--login">
            <h2 className="login-header">LiveDoc Sitebuilder</h2>
            <h4 className="login-text">Please log in to continue</h4>
            <button type="button" className="btn btn-dark" onClick={handleLogin}>
                Log in with LiveDoc
            </button>
        </div>
    );
}
